// extracted by mini-css-extract-plugin
module.exports = {"main":"HalfCircleProgress_main__jiMg6","current":"HalfCircleProgress_current__NawbO"};